import { render } from "./MenuMobile.vue?vue&type=template&id=9715b73a&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"

import "./MenuMobile.vue?vue&type=style&index=0&id=9715b73a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/sma-order/sma-order/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9715b73a"]])

export default __exports__